import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_MENU_ITEMS, leaveForRfid } from '../helpers/inEadinApp';

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

// Top bar shown instead of Eadin's sidebar when a page runs inside the
// Eadin iPad app: the app's own menu, and nothing else from the site.
export default function InAppBar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const current = APP_MENU_ITEMS.find((item) => item.path === location.pathname);

  const go = (item) => {
    setOpen(false);
    if (item.path) navigate(item.path);
    else leaveForRfid();
  };

  return (
    <>
      <header
        data-testid="in-app-bar"
        className="sticky top-0 z-40 flex items-center gap-3 bg-[#1d2129] px-4 pb-2 text-white"
        style={{ paddingTop: 'calc(8px + env(safe-area-inset-top))' }}
      >
        <button
          type="button"
          aria-label="Open menu"
          aria-expanded={open}
          onClick={() => setOpen(true)}
          className="rounded-lg p-2 hover:bg-white/10"
        >
          <MenuIcon />
        </button>
        <h1 className="text-lg font-semibold">{current?.label || 'Eadin'}</h1>
      </header>
      {open && (
        <div className="fixed inset-0 z-50">
          <button type="button" aria-label="Close menu" className="absolute inset-0 h-full w-full bg-[#0f1115]/40" onClick={() => setOpen(false)} />
          <nav
            aria-label="App sections"
            className="absolute bottom-0 left-0 top-0 w-72 max-w-[85%] bg-white p-3 shadow-xl"
            style={{ paddingTop: 'calc(12px + env(safe-area-inset-top))' }}
          >
            <div className="mb-3 px-2 text-base font-bold text-[#0f1115]">Eadin</div>
            {APP_MENU_ITEMS.map((item) => (
              <button
                key={item.id}
                type="button"
                aria-current={item.path === location.pathname ? 'page' : undefined}
                onClick={() => go(item)}
                className={`mb-1 block w-full rounded-lg px-3 py-3 text-left ${item.path === location.pathname ? 'bg-[#eef0f3]' : 'hover:bg-[#f5f6f8]'}`}
              >
                <span className="block text-base font-semibold text-[#0f1115]">{item.label}</span>
                <span className="block text-sm text-[#5b6170]">{item.subtitle}</span>
              </button>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
